import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import piniaPersist from 'pinia-plugin-persist'
import { loadVueform } from './plugins/loadVueform'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPersist)

app.use(pinia)
app.use(router)

app.mount('#app')

// Dynamically load and initialize Sentry only when entering the main page or the results page.
// Both render a Vueform; wait for it so Sentry doesn't compete for bandwidth with the form.
let sentryInitialized = false
router.afterEach((to) => {
  if (['home', 'result'].includes(to.name) && !sentryInitialized) {
    sentryInitialized = true
    loadVueform()
      .catch(() => {})
      .then(() => import('@sentry/vue'))
      .then((Sentry) => {
        Sentry.init({
          app,
          dsn: 'https://e7df5d8d090fb98c487947678125aae8@sentry.d-o.li/4',
          integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.captureConsoleIntegration(),
            Sentry.httpClientIntegration()
          ],
          tracesSampleRate: 0.1
        })
      })
  }
})
